// Author :    Austin N. Hunt
// File Role:    Defines all constants for the web app.
// Looking forward: It may become helpful to break this file up? Not sure.

//Session:
export const INIT = 'INIT';
export const LOGIN = 'LOGIN';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGOUT = 'LOGOUT';
export const SIGNUP = 'SIGNUP';
export const SIGNUP_FAILED = 'SIGNUP_FAILED';
export const BEGIN_PASSWORD_RESET = 'BEGIN_PASSWORD_RESET';
export const SET_SOCKETS_CONNECTED = 'SET_SOCKETS_CONNECTED';
export const SET_SOCKETS_DISCONNECTED = 'SET_SOCKETS_DISCONNECTED';
export const CHECK_AUTHORIZATION = 'CHECK_AUTHORIZATION';
export const BEGIN_VALIDATE_ACCOUNT = 'BEGIN_VALIDATE_ACCOUNT';
export const TOGGLE_MAIN_MENU = 'TOGGLE_MAIN_MENU';
//Fetch
export const FETCH_DATA = 'FETCH_DATA';

//Dashboard
export const INIT_DASHBOARD = 'INIT_DASHBOARD';


//Client
export const FETCH_CLIENT = 'FETCH_CLIENT';
export const FETCH_CLIENT_FAILED = 'FETCH_CLIENT_FAILED';
export const RECEIVE_CLIENT = 'RECEIVE_CLIENT';
export const CLIENT_UPDATE_SUCCESS = 'CLIENT_UPDATE_SUCCESS';
export const CLIENT_UPDATE_FAILED = 'CLIENT_UPDATE_FAILED';
export const CLIENT_INTERACTION_NEW = 'CLIENT_INTERACTION_NEW';
export const CLIENT_INTERACTION_NEW_SUCCESS = 'CLIENT_INTERACTION_NEW_SUCCESS';
export const CLIENT_INTERACTION_NEW_FAILED = 'CLIENT_INTERACTION_NEW_FAILED';
export const ADD_CLIENT_INTERACTION = 'ADD_CLIENT_INTERACTION';
export const CLIENT_TASK_NEW = 'CLIENT_TASK_NEW';
export const CLIENT_TASK_NEW_SUCCESS = 'CLIENT_TASK_NEW_SUCCESS';
export const CLIENT_TASK_UPDATE_SUCCESS = 'CLIENT_TASK_UPDATE_SUCCESS';
export const FETCH_CLIENT_RECENT_IMPACTS = 'FETCH_CLIENT_RECENT_IMPACTS';
export const FETCH_CLIENT_RECENT_IMPACTS_FAILED = 'FETCH_CLIENT_RECENT_IMPACTS_FAILED';
export const RECEIVE_CLIENT_RECENT_IMPACTS = 'RECEIVE_CLIENT_RECENT_IMPACTS';
export const ADD_CLIENT_TASK = 'ADD_CLIENT_TASK';
export const CLIENT_ASSIGN_SUCCESS = 'CLIENT_ASSIGN_SUCCESS';
export const CLIENT_ASSIGN_FAILED = 'CLIENT_ASSIGN_FAILED';
export const CLEAR_CLIENT = 'CLEAR_CLIENT';
export const DELETE_CLIENT_TASK = 'DELETE_CLIENT_TASK';
export const UPDATE_CLIENT_TASK = 'UPDATE_CLIENT_TASK';
export const SHOW_CREATE_CLIENT = 'SHOW_CREATE_CLIENT';
export const HIDE_CREATE_CLIENT = 'HIDE_CREATE_CLIENT';
export const UPDATE_CURRENT_PLACE = 'UPDATE_CURRENT_PLACE';

//Pipeline
export const SAVE_PIPELINE = 'SAVE_PIPELINE';
export const CREATE_PIPELINE_SUCCESS = 'CREATE_PIPELINE_SUCCESS';
export const CREATE_PIPELINE_FAILED = 'CREATE_PIPELINE_FAILED';
export const UPDATE_PIPELINE = 'UPDATE_PIPELINE';
export const UPDATE_PIPELINE_SUCCESS = 'UPDATE_PIPELINE_SUCCESS';
export const UPDATE_PIPELINE_FAILED = 'UPDATE_PIPELINE_FAILED';
export const FETCH_PIPELINE = 'FETCH_PIPELINE';
export const FETCH_PIPELINE_SUCCESS = 'FETCH_PIPELINE_SUCCESS';
export const FETCH_PIPELINE_FAILED = 'FETCH_PIPELINE_FAILED';
export const RECIEVE_PIPELINE = 'RECIEVE_PIPELINE';
export const UPDATE_PIPELINE_SUMMARY = 'UPDATE_PIPELINE_SUMMARY';
//Contacts
export const FETCH_CONTACTS = 'FETCH_CONTACTS';
export const FETCH_CONTACTS_SUCCESS = 'FETCH_CONTACTS_SUCCESS';
export const FETCH_CONTACTS_FAILED = 'FETCH_CONTACTS_FAILED';
export const CREATE_CONTACT = 'CREATE_CONTACT';
export const CREATE_CONTACT_SUCCESS = 'CREATE_CONTACT_SUCCESS';
export const DELETE_CONTACT = 'DELETE_CONTACT';
export const DELETE_CONTACT_SUCCESS = 'DELETE_CONTACT_SUCCESS';
export const CREATE_CONTACT_FAILED = 'CREATE_CONTACT_FAILED';
export const CLEAR_CONTACTS = 'CLEAR_CONTACTS';

//Incidents
export const RECEIVE_CLIENT_INCIDENTS = 'RECEIVE_CLIENT_INCIDENTS';
export const FETCH_CLIENT_INCIDENTS_FAILED = 'FETCH_CLIENT_INCIDENTS_FAILED';
export const FETCH_CLIENT_INCIDENTS = 'FETCH_CLIENT_INCIDENTS';
export const FETCH_CLIENT_NEXT_INCIDENTS = 'FETCH_CLIENT_NEXT_INCIDENTS';
export const CLIENT_NEW_INCIDENT = 'CLIENT_NEW_INCIDENT';
export const ADD_CLIENT_INCIDENT = 'ADD_CLIENT_INCIDENT';
export const FETCH_CLIENT_INCIDENT = 'FETCH_CLIENT_INCIDENT';
export const FETCH_CLIENT_INCIDENT_SUCCESS = 'FETCH_CLIENT_INCIDENT_SUCCESS';
export const FETCH_CLIENT_INCIDENT_FAILED = 'FETCH_CLIENT_INCIDENT_FAILED';
export const CLIENT_INCIDENT_NEW_SUCCESS = 'CLIENT_INCIDENT_NEW_SUCCESS';
export const CLIENT_INCIDENT_NEW_FAILED = 'CLIENT_INCIDENT_NEW_FAILED';
export const RECEIVE_CLIENT_INCIDENT = 'RECEIVE_CLIENT_INCIDENT';
export const PREVIEW_INCIDENT = 'PREVIEW_INCIDENT';
export const START_CREATE_INCIDENT = 'START_CREATE_INCIDENT';
export const HIDE_CREATE_INCIDENT = 'HIDE_CREATE_INCIDENT';
export const UPDATE_INCIDENT = 'UPDATE_INCIDENT';
export const CLIENT_INCIDENT_EDIT_SUCCESS = 'CLIENT_INCIDENT_EDIT_SUCCESS';
export const CLIENT_INCIDENT_EDIT_FAILED = 'CLIENT_INCIDENT_EDIT_FAILED';
export const GENERATE_INCIDENT_REPORT = 'GENERATE_INCIDENT_REPORT';
export const ADD_INCIDENT_REPORT_PDF = 'ADD_INCIDENT_REPORT_PDF';
export const TOGGLE_INCIDENT_REPORT_SELECTED = 'TOGGLE_INCIDENT_REPORT_SELECTED';
export const TOGGLE_GENERATING_REPORT = 'TOGGLE_GENERATING_REPORT';
export const PROMPT_NEW_REPORT_DOWNLOAD = 'PROMPT_NEW_REPORT_DOWNLOAD';
export const HIDE_NEW_REPORT_PROMPT = 'HIDE_NEW_REPORT_PROMPT';
export const BEGIN_DELETE_REPORT_PDFS = 'BEGIN_DELETE_REPORT_PDFS';
export const TOGGLE_DELETING_REPORT_PDFS = 'TOGGLE_DELETING_REPORT_PDFS';
export const DELETE_REPORT_PDFS = 'DELETE_REPORT_PDFS';

  //Sockets
export const JOIN_SOCKET_CHANNEL = 'JOIN_SOCKET_CHANNEL';
export const LEAVE_SOCKET_CHANNEL = 'LEAVE_SOCKET_CHANNEL';
export const LEAVE_SOCKET_CHANNEL_SUCCESS = 'LEAVE_SOCKET_CHANNEL_SUCCESS';
export const SEND_SOCKET_EVENT = 'SEND_SOCKET_EVENT';
export const JOIN_SOCKET_CHANNEL_FAILED = 'JOIN_SOCKET_CHANNEL_FAILED';
export const JOIN_SOCKET_CHANNEL_SUCCESS = 'JOIN_SOCKET_CHANNEL_SUCCESS';

//App
export const UPDATE_TOKEN = 'UPDATE_TOKEN';
export const UPDATE_URL = 'UPDATE_URL';
export const UPDATE_BASE_URL = 'UPDATE_BASE_URL';
export const UPDATE_SERVER_URL = 'UPDATE_SERVER_URL';
export const UPDATE_SOCKET_URL = 'UPDATE_SOCKET_URL';
export const UPDATE_SOCKETCLUSTER_URL = 'UPDATE_SOCKETCLUSTER_URL';
export const UPDATE_IMAGES_PATH = 'UPDATE_IMAGES_PATH';
export const UPDATE_AUTHORIZED_USER = 'UPDATE_AUTHORIZED_USER';
export const UPDATE_AUTHORIZED_USER_SETTINGS = 'UPDATE_AUTHORIZED_USER_SETTINGS';
export const UPDATE_AUTHORIZATION_STATE = 'UPDATE_AUTHORIZATION_STATE';
export const UPDATE_AUTHORIZED_USER_SCREEN_NAME = 'UPDATE_AUTHORIZED_USER_SCREEN_NAME';
export const UPDATE_AUTHORIZED_USER_AVATAR = 'UPDATE_AUTHORIZED_USER_AVATAR';

//Posts
export const UPDATE_POST = 'UPDATE_POST';
export const UPDATE_POST_TITLE = 'UPDATE_POST_TITLE';
export const UPDATE_POST_SLUG = 'UPDATE_POST_SLUG';
export const UPDATE_POST_CONTENT = 'UPDATE_POST_CONTENT';
export const UPDATE_POST_EXCERPT = 'UPDATE_POST_EXCERPT';
export const ADD_POST_CATEGORY = 'ADD_POST_CATEGORY';
export const DELETE_POST_CATEGORY = 'DELETE_POST_CATEGORY';
export const CLEAR_POST = 'CLEAR_POST';

//Categories
export const UPDATE_POST_CATEGORIES = 'UPDATE_POST_CATEGORIES';
export const UPDATE_POST_TAGS = 'UPDATE_POST_TAGS';
export const ADD_CATEGORY = 'ADD_CATEGORY';
export const REFRESH_CATEGORIES = 'REFRESH_CATEGORIES';

//Users
export const GET_USER = 'GET_USER';
export const CLEAR_USER = 'CLEAR_USER';
export const BEGIN_INIT_USERS = 'BEGIN_INIT_USERS';
export const END_INIT_USERS = 'END_INIT_USERS';
export const UPDATE_USER_ERRORS = 'UPDATE_USER_ERRORS';
export const ADD_USER = 'ADD_USER';
export const INIT_CHILDREN = 'INIT_CHILDREN';
export const DELETE_USER = 'DELETE_USER';
export const REMOVE_USER = 'REMOVE_USER';
export const ADD_USERS = 'ADD_USERS';
export const SET_USER_PARENT = 'SET_USER_PARENT';
export const EDIT_USER = 'EDIT_USER';
export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS';
export const EDIT_USER_FAILED = 'EDIT_USER_FAILED';
export const INIT_CREATE_USER = 'INIT_CREATE_USER';
export const BEGIN_CREATE_USER = 'BEGIN_CREATE_USER';
export const BEGIN_EDIT_USER = 'BEGIN_EDIT_USER';
export const BEGIN_EDIT_USER_SAGA = 'BEGIN_EDIT_USER_SAGA';
export const UPDATE_USER = 'UPDATE_USER';
export const BEGIN_DELETE_USER = 'BEGIN_DELETE_USER';
export const SHOW_DELETE_USER_PROMPT = 'SHOW_DELETE_USER_PROMPT';
export const HIDE_DELETE_USER_PROMPT = 'HIDE_DELETE_USER_PROMPT';
export const SET_OPEN_TAB = 'SET_OPEN_TAB';
export const SET_PASSWORD_TAB_DIRTY = 'SET_PASSWORD_TAB_DIRTY';
export const SET_GEN_INFO_TAB_DIRTY = 'SET_GEN_INFO_TAB_DIRTY';
export const SET_PROFILE_PIC_TAB_DIRTY = 'SET_PROFILE_PIC_TAB_DIRTY';
export const UPDATE_TMP_USER = 'UPDATE_TMP_USER';
export const SHOW_EDIT_USER = 'SHOW_EDIT_USER';
export const SHOW_CREATE_USER = 'SHOW_CREATE_USER';
export const HIDE_EDIT_USER = 'HIDE_EDIT_USER';
export const HIDE_CREATE_USER = 'HIDE_CREATE_USER';
export const SHOW_VIEW_USER = 'SHOW_VIEW_USER';
export const HIDE_VIEW_USER = 'HIDE_VIEW_USER';
export const POPULATE_RECENT_CLIENTS = 'POPULATE_RECENT_CLIENTS';
export const POPULATE_RECENT_MAPS = 'POPULATE_RECENT_MAPS';
export const INIT_DASHBOARD_AVATARS = 'INIT_DASHBOARD_AVATARS';
export const INIT_USERS_CHILDREN = 'INIT_USERS_CHILDREN';
export const ADD_CLIENT_TO_USER = 'ADD_CLIENT_TO_USER';
export const BEGIN_SIGNUP_CLIENT_ADMIN = 'BEGIN_SIGNUP_CLIENT_ADMIN';
export const BEGIN_LOGIN_PROXY_ACCOUNT = 'BEGIN_LOGIN_PROXY_ACCOUNT';
export const LOG_IN_PROXY_ACCOUNT = 'LOG_IN_PROXY_ACCOUNT';
export const LOG_OUT_PROXY_ACCOUNT = 'LOG_OUT_PROXY_ACCOUNT';
export const UPDATE_PROXY_ACCOUNT = 'UPDATE_PROXY_ACCOUNT';
export const UPDATE_PROXY_CHILDREN = 'UPDATE_PROXY_CHILDREN';
export const INIT_PROXY_USER_LOGIN = 'INIT_PROXY_USER_LOGIN';
export const SET_TMP_USER_ROLES = 'SET_TMP_USER_ROLES';
export const SET_TMP_USER_FEATURES = 'SET_TMP_USER_FEATURES';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILED = 'CREATE_USER_FAILED';
export const TOGGLE_MAPS_INIT_FLAG = 'TOGGLE_MAPS_INIT_FLAG';
export const BEGIN_USER_SIGN_UP = 'BEGIN_USER_SIGN_UP';
export const TOGGLE_FETCHING_TEMP_HASH = 'TOGGLE_FETCHING_TEMP_HASH';
export const RESETING_PASSWORD = 'RESETING_PASSWORD';
export const BEGIN_TEMP_HASH_VALIDATION = 'BEGIN_TEMP_HASH_VALIDATION';
export const BEGIN_SAVE_NEW_PASSWORD = 'BEGIN_SAVE_NEW_PASSWORD';

//Features
export const TOGGLE_SHOW_FEATURE = 'TOGGLE_SHOW_FEATURE';
export const CLEAR_SHOW_FEATURE = 'CLEAR_SHOW_FEATURE';
export const BEGIN_INIT_FEATURES_TREE = 'BEGIN_INIT_FEATURES_TREE';
export const BEGIN_ENABLE_FEATURES = 'BEGIN_ENABLE_FEATURES';
export const UPDATE_FEATURES_LIST = 'UPDATE_FEATURES_LIST';
export const UPDATE_FEATURES_TREE = 'UPDATE_FEATURES_TREE';
export const UPDATE_FEATURES_OWNER = 'UPDATE_FEATURES_OWNER';
export const ADD_CHILD_TO_FEATURE = 'ADD_CHILD_TO_FEATURE';
export const BEGIN_DISABLE_FEATURES = 'BEGIN_DISABLE_FEATURES';
export const TOGGLE_FETCHING_FEATURES = 'TOGGLE_FETCHING_FEATURES';

//Maps
export const SET_CURRENT_MAP = 'SET_CURRENT_MAP';
export const UPDATE_MAP = 'UPDATE_MAP';
export const UPDATE_MAP_SEARCH_LIST = 'UPDATE_MAP_SEARCH_LIST';
export const CLEAR_MAP_SEARCH_LIST = 'CLEAR_MAP_SEARCH_LIST';
export const SEARCHING_MAPS = 'SEARCHING_MAPS';
export const DONE_SEARCHING_MAPS = 'DONE_SEARCHING_MAPS';
export const UPDATE_PLACES = 'UPDATE_PLACES';
export const UPDATE_DATE = 'UPDATE_DATE';
export const SET_PURCHASE_MAP = 'SET_PURCHASE_MAP';
export const HIDE_PURCHASE_MAP = 'HIDE_PURCHASE_MAP';
export const SHOW_PURCHASE_MAP = 'SHOW_PURCHASE_MAP';
export const UPDATE_STORM_DATA = 'UPDATE_STORM_DATA';
export const FETCH_MAP = 'FETCH_MAP';
export const FETCH_MAP_SUCCESS = 'FETCH_MAP_SUCCESS';
export const FETCH_MAP_FAILURE = 'FETCH_MAP_FAILURE';
export const FAVORITE_MAP = 'FAVORITE_MAP';
export const FAVORITE_MAP_SUCCESS = 'FAVORITE_MAP_SUCCESS';
export const FAVORITE_MAP_FAILED = 'FAVORITE_MAP_FAILED';
export const CLEAR_DOWNLOADED_MAPS = 'CLEAR_DOWNLOADED_MAPS';

//Map Creator
export const INIT_MAP_CREATOR = 'INIT_MAP_CREATOR';
export const SET_CURRENT_MAP_CREATOR_MAP = 'SET_CURRENT_MAP_CREATOR_MAP';
export const SET_CURRENT_MAP_CREATOR_FEATURE = 'SET_CURRENT_MAP_CREATOR_FEATURE';
export const INIT_MAP_CREATOR_MAPS_LIST = 'INIT_MAP_CREATOR_MAPS_LIST';
export const UPDATE_MAP_PROPERTIES = 'UPDATE_MAP_PROPERTIES';
export const UPDATE_CURRENT_MAP_PROPERTIES = 'UPDATE_CURRENT_MAP_PROPERTIES';
export const UPDATE_CURRENT_MAP_FEATURE = 'UPDATE_CURRENT_MAP_FEATURE';
export const UPDATE_MAP_STORM_DATE = 'UPDATE_MAP_STORM_DATE';
export const UPDATE_SWATH_OPACITY = 'UPDATE_SWATH_OPACITY';
export const UPDATE_DRAWING_MODE = 'UPDATE_DRAWING_MODE';
export const INIT_NEW_MAP = 'INIT_NEW_MAP';
export const CANCEL_NEW_MAP = 'CANCEL_NEW_MAP';
export const SAVE_NEW_MAP = 'SAVE_NEW_MAP';
export const CREATE_MAP_FAILURE = 'CREATE_MAP_FAILURE';
export const CREATE_MAP_SUCCESS = 'CREATE_MAP_SUCCESS';
export const ADD_NEW_MAP = 'ADD_NEW_MAP';
export const INIT_EDIT_MAP = 'INIT_EDIT_MAP';
export const CANCEL_EDIT_MAP = 'CANCEL_EDIT_MAP';
export const SAVE_EDITED_MAP = 'SAVE_EDITED_MAP';
export const EDIT_MAP_FAILURE = 'EDIT_MAP_FAILURE';
export const EDIT_MAP_SUCCESS = 'EDIT_MAP_SUCCESS';
export const INIT_DELETE_MAP = 'INIT_DELETE_MAP';
export const CANCEL_DELETE_MAP = 'CANCEL_DELETE_MAP';
export const DELETE_MAP_FAILURE = 'DELETE_MAP_FAILURE';
export const DELETE_MAP_SUCCESS = 'DELETE_MAP_SUCCESS';
export const CREATE_MAP_FEATURE = 'CREATE_MAP_FEATURE';
export const CREATE_MAP_FEATURE_SUCCESS = 'CREATE_MAP_FEATURE_SUCCESS';
export const CREATE_MAP_FEATURE_FAILURE = 'CREATE_MAP_FEATURE_FAILURE';
export const EDIT_MAP_FEATURE_SUCCESS = 'EDIT_MAP_FEATURE_SUCCESS';
export const EDIT_MAP_FEATURE_FAILURE = 'EDIT_MAP_FEATURE_FAILURE';
export const INIT_DELETE_MAP_FEATURE = 'INIT_DELETE_MAP_FEATURE';
export const CANCEL_DELETE_MAP_FEATURE = 'CANCEL_DELETE_MAP_FEATURE';
export const DELETE_MAP_FEATURE_FAILURE = 'DELETE_MAP_FEATURE_FAILURE';
export const DELETE_MAP_FEATURE_SUCCESS = 'DELETE_MAP_FEATURE_SUCCESS';
export const TOGGLE_MAP_HIDDEN = 'TOGGLE_MAP_HIDDEN';
export const TOGGLE_FEATURE_HIDDEN = 'TOGGLE_FEATURE_HIDDEN';
export const TOGGLE_SHOW_DISCONNECTED_SOCKET_ERROR = 'TOGGLE_SHOW_DISCONNECTED_SOCKET_ERROR';
export const TOGGLE_HIDE_KML_LAYER = 'TOGGLE_HIDE_KML_LAYER';
export const UPLOAD_KML_LAYERS = 'UPLOAD_KML_LAYERS';
export const REMOVE_KML_LAYER = 'REMOVE_KML_LAYER';
export const TOGGLE_UPLOADING_KML_LAYERS = 'TOGGLE_UPLOADING_KML_LAYERS';
export const TOGGLE_DELETING_KML_LAYERS = 'TOGGLE_DELETING_KML_LAYERS';
export const UPLOAD_POLYGONS = 'UPLOAD_POLYGONS';
export const TOGGLE_UPLOADING_POLYGONS = 'TOGGLE_UPLOADING_POLYGONS';
export const MOVE_MAP_FEATURE_SUCCESS = 'MOVE_MAP_FEATURE_SUCCESS';
export const MOVE_MAP_FEATURE_FAILURE = 'MOVE_MAP_FEATURE_FAILURE';
export const TOGGLE_MARK_CURRENT_MAP_FINISHED = 'TOGGLE_MARK_CURRENT_MAP_FINISHED';
export const CONFIRM_EDIT_MAP_WARNING = 'CONFIRM_EDIT_MAP_WARNING';
export const CANCEL_EDIT_MAP_WARNING = 'CANCEL_EDIT_MAP_WARNING';
export const TOGGLE_SHOW_EDIT_MAP_WARNING_MODAL = 'TOGGLE_SHOW_EDIT_MAP_WARNING_MODAL';
export const TOGGLE_WAITING_FOR_MAP_CREATOR_RESPONSE = 'TOGGLE_WAITING_FOR_MAP_CREATOR_RESPONSE';
export const HANDLE_MAP_CREATOR_PLACES_CHANGE = 'HANDLE_MAP_CREATOR_PLACES_CHANGE';
export const UPLOAD_MAP_CREATOR_MARKER = 'UPLOAD_MAP_CREATOR_MARKER';
export const TOGGLE_PROCESSING_MAP_CREATOR_MARKER = 'TOGGLE_PROCESSING_MAP_CREATOR_MARKER';
export const INIT_MAP_CREATOR_MARKER_TYPES = 'INIT_MAP_CREATOR_MARKER_TYPES';
export const UPDATE_CURRENT_MAP_CREATOR_MARKER_TYPE = 'UPDATE_CURRENT_MAP_CREATOR_MARKER_TYPE';
export const TOGGLE_SHOW_MARKER_EDITOR_ICON_MODAL = 'TOGGLE_SHOW_MARKER_EDITOR_ICON_MODAL';
export const TOGGLE_SHOW_MARKER_EDITOR_INFO_WINDOW_MODAL = 'TOGGLE_SHOW_MARKER_EDITOR_INFO_WINDOW_MODAL';
export const UPLOAD_MAP_CREATOR_INFO_WINDOW_IMAGE = 'UPLOAD_MAP_CREATOR_INFO_WINDOW_IMAGE';
export const TOGGLE_UPLOADING_MAP_CREATOR_INFO_WINDOW_IMAGE = 'TOGGLE_UPLOADING_MAP_CREATOR_INFO_WINDOW_IMAGE';
export const TOGGLE_DELETING_MARKERS = 'TOGGLE_DELETING_MARKERS';
export const TOGGLE_SHOW_DELETE_MAP_CREATOR_MARKER_TYPE_MODAL = 'TOGGLE_SHOW_DELETE_MAP_CREATOR_MARKER_TYPE_MODAL';
export const UPDATE_MAP_CREATOR_TMP_INFO_WINDOW_IMAGE = 'UPDATE_MAP_CREATOR_TMP_INFO_WINDOW_IMAGE';
export const CANCEL_UPDATE_MAP_CREATOR_INFO_WINDOW = 'CANCEL_UPDATE_MAP_CREATOR_INFO_WINDOW';
export const DELETE_MAP_CREATOR_MARKER_TYPE = 'DELETE_MAP_CREATOR_MARKER_TYPE';
export const DELETE_MAP_CREATOR_MARKER_TYPE_SUCCESS = 'DELETE_MAP_CREATOR_MARKER_TYPE_SUCCESS';
export const UPDATE_MARKER_FILTER_USER = 'UPDATE_MARKER_FILTER_USER';
export const TOGGLE_SHOW_EDIT_MAP_MODAL = 'TOGGLE_SHOW_EDIT_MAP_MODAL';
export const TOGGLE_SHOW_CREATE_MAP_MODAL = 'TOGGLE_SHOW_CREATE_MAP_MODAL';
export const SET_MAP_CREATOR_PROPERTIES = 'SET_MAP_CREATOR_PROPERTIES';

//Search Maps
export const ADD_FOUND_MAP = 'ADD_FOUND_MAP';
export const ADD_FOUND_MAPS = 'ADD_FOUND_MAPS';
export const REMOVE_FOUND_MAP = 'REMOVE_FOUND_MAP';
export const ADD_DOWNLOADED_MAP = 'ADD_DOWNLOADED_MAP';
export const REMOVE_DOWNLOADED_MAP = 'REMOVE_DOWNLOADED_MAP';
export const SHOW_DOWNLOADED_MAP = 'SHOW_DOWNLOADED_MAP';
export const TOGGLE_SHOW_DOWNLOADED_MAP_MARKERS = 'TOGGLE_SHOW_DOWNLOADED_MAP_MARKERS';
export const HIDE_DOWNLOADED_MAP = 'HIDE_DOWNLOADED_MAP';
export const SHOW_DOWNLOADED_MAPS = 'SHOW_DOWNLOADED_MAPS';
export const HIDE_DOWNLOADED_MAPS = 'HIDE_DOWNLOADED_MAPS';
export const SHOW_DOWNLOADED_MAP_INFO = 'SHOW_DOWNLOADED_MAP_INFO';
export const HIDE_DOWNLOADED_MAP_INFO = 'HIDE_DOWNLOADED_MAP_INFO';
export const SHOW_FOUND_MAPS = 'SHOW_FOUND_MAPS';
export const HIDE_FOUND_MAPS = 'HIDE_FOUND_MAPS';

//Markers
export const TOGGLE_CANVASSING = 'TOGGLE_CANVASSING';
export const FETCH_MARKERS = 'FETCH_MARKERS';
export const SET_MARKERS_FILTERS = 'SET_MARKERS_FILTERS';
export const FETCH_MARKERS_SUCCESS = 'FETCH_MARKERS_SUCCESS';
export const FETCH_MARKERS_FAILED = 'FETCH_MARKERS_FAILED';
export const FETCH_NEXT_MARKERS = 'FETCH_NEXT_MARKERS';
export const UDPATE_MARKER_SUCCESS = 'UPDATE_MARKER_SUCCESS';
export const UDPATE_MARKER_FAILED = 'UPDATE_MARKER_FAILED';
export const CREATE_MARKER = 'CREATE_MARKER';
export const CREATE_MARKER_SUCCESS = 'CREATE_MARKER_SUCCESS';
export const CREATE_MARKER_FAILED = 'CREATE_MARKER_FAILED';
export const UPDATE_MARKER = 'UPDATE_MARKER';
export const UPDATE_MARKER_SUCCESS = 'UPDATE_MARKER_SUCCESS';
export const UPDATE_MARKER_FAILED = 'UPDATE_MARKER_FAILED';
export const DELETE_MARKER = 'DELETE_MARKER';
export const DELETE_MARKER_SUCCESS = 'DELETE_MARKER_SUCCESS';
export const DELETE_MARKER_FAILED = 'DELETE_MARKER_FAILED';
export const TOGGLE_SHOW_MARKER_SETTINGS = 'TOGGLE_SHOW_MARKER_SETTINGS';
export const SET_MARKER_TYPES = 'SET_MARKER_TYPES';
export const INIT_MAP_MARKER_TYPES = 'INIT_MAP_MARKER_TYPES';
export const SET_NEW_MARKER_TYPE = 'SET_NEW_MARKER_TYPE';
export const SET_MARKER_SUCCESS = 'SET_MARKER_SUCCESS';
export const UPDATE_MARKER_NAME_SUCCESS = 'UPDATE_MARKER_NAME_SUCCESS';
export const TOGGLE_SHOW_CREATE_NEW_MARKER_MODAL = 'TOGGLE_SHOW_CREATE_NEW_MARKER_MODAL';
export const TOGGLE_SHOW_EDIT_MARKER_MODAL = 'TOGGLE_SHOW_EDIT_MARKER_MODAL';
export const UNSET_MARKER_SUCCESS = 'UNSET_MARKER_SUCCESS';
export const TOGGLE_MARKER_TYPES_INITIALIZED = 'TOGGLE_MARKER_TYPES_INITIALIZED';
export const UPDATE_MARKER_FILTERS = 'UPDATE_MARKER_FILTERS';

//Notifications
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const RECEIVE_NOTIFICATIONS = 'RECEIVE_NOTIFICATIONS';
export const NOTIFICATION_CREATED = 'NOTIFICATION_CREATED';
export const NOTIFICATION_UPDATED = 'NOTIFICATION_UPDATED';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';
//Clients
export const ADD_CLIENT = 'ADD_CLIENT';
export const SELECT_CLIENT = 'SELECT_CLIENT';
export const DELETE_CLIENT = 'DELETE_CLIENT';
export const DELETE_CLIENT_SUCCESS = 'DELETE_CLIENT_SUCCESS';
export const DELETE_CLIENT_FAILED = 'DELETE_CLIENT_FAILED';
export const UPDATE_CLIENT = 'UPDATE_CLIENT';
export const UPDATE_CLIENTS = 'UPDATE_CLIENTS';
export const CLEAR_CLIENTS = 'CLEAR_CLIENTS';
export const ADD_CLIENT_ERROR = 'ADD_CLIENT_ERROR';
export const SET_CLIENT_PAGE_SIZE = 'SET_CLIENT_PAGE_SIZE';
export const SET_CLIENT_SORT_COLUMN = 'SET_CLIENT_SORT_COLUMN';
export const SET_CLIENTS_FILTERS = 'SET_CLIENTS_FILTERS';
export const UPDATE_TABLE_PAGE_SIZE = 'UPDATE_TABLE_PAGE_SIZE';
export const ADD_CLIENTS_FILTER = 'ADD_CLIENTS_FILTER';
export const FETCH_CLIENTS_FILTERS = 'FETCH_CLIENTS_FILTERS';
export const FETCH_CLIENTS_WITH_FILTERS = 'FETCH_CLIENTS_WITH_FILTERS';
export const SET_CLIENT_COLUMNS = 'SET_CLIENT_COLUMNS';
export const UPDATE_CLIENTS_BOUNDS = 'UPDATE_CLIENTS_BOUNDS';
export const TOGGLE_FETCHING_CLIENT = 'TOGGLE_FETCHING_CLIENT';
export const TOGGLE_FETCHING_CLIENTS = 'TOGGLE_FETCHING_CLIENTS';
export const TOGGLE_VIEWING_CLIENTS_MAP = 'TOGGLE_VIEWING_CLIENTS_MAP';
export const UPDATE_CLIENTS_TABLE_LIST = 'UPDATE_CLIENTS_TABLE_LIST';
export const UPDATE_CLIENTS_MAP_LIST = 'UPDATE_CLIENTS_MAP_LIST';
export const ZOOM_TO_CLIENT = 'ZOOM_TO_CLIENT';

export const FETCH_CLIENTS = 'FETCH_CLIENTS';
export const FETCH_NEXT_CLIENTS = 'FETCH_NEXT_CLIENTS';
export const FETCH_PREV_CLIENTS = 'FETCH_PREV_CLIENTS';

export const FETCH_CLIENTS_FILTERS_SUCCEEDED = 'FETCH_CLIENTS_FILTERS_SUCCEEDED';
export const FETCH_CLIENTS_FILTERS_FAILED = 'FETCH_CLIENTS_FILTERS_FAILED';
export const FETCH_CLIENTS_SUCCEEDED = 'FETCH_CLIENTS_SUCCEEDED';
export const FETCH_CLIENTS_FAILED = 'FETCH_CLIENTS_FAILED';

export const CLEAR_FETCHED_CLIENTS_FILTERS = 'CLEAR_FETCHED_CLIENTS_FILTERS';
export const CLEAR_CLIENTS_FILTERS = 'CLEAR_CLIENTS_FILTERS';
export const UPDATE_CLIENTS_FILTERS = 'UPDATE_CLIENTS_FILTERS';
export const TOGGLE_FILTER_CLIENTS_TABLE_BY_MAP_BOUNDS = 'TOGGLE_FILTER_CLIENTS_TABLE_BY_MAP_BOUNDS';
export const UPDATE_CLIENTS_TABLE_OPEN_STATE = 'UPDATE_CLIENTS_TABLE_OPEN_STATE';

export const UPDATE_CLIENTS_FIELDS = 'UPDATE_CLIENTS_FIELDS';

export const CLIENT_FIELD_CREATED = 'CLIENT_FIELD_CREATED';
export const CLIENT_FIELD_DELETED = 'CLIENT_FIELD_DELETED';
export const CLIENT_FIELD_UPDATED = 'CLIENT_FIELD_UPDATED';

export const SHOW_SELECTING_CLIENT_COLUMNS = 'SHOW_SELECTING_CLIENT_COLUMNS';
export const HIDE_SELECTING_CLIENT_COLUMNS = 'HIDE_SELECTING_CLIENT_COLUMNS';
export const TOGGLE_CLIENT_COLUMN = 'TOGGLE_CLIENT_COLUMN';

//Integrations
export const TOGGLE_JOB_NIMBUS_AUTH_ERROR = 'TOGGLE_JOB_NIMBUS_AUTH_ERROR';

//For Grabbing All Features
export const UPDATE_FEATURES = 'UPDATE_FEATURES';

//Account constants
export const SHOW_ADD_CARD = 'SHOW_ADD_CARD';
export const HIDE_ADD_CARD = 'HIDE_ADD_CARD';
export const SHOW_DELETE_CARD = 'SHOW_DELETE_CARD';
export const HIDE_DELETE_CARD = 'HIDE_DELETE_CARD';
export const SHOW_EDIT_CARD = 'SHOW_EDIT_CARD';
export const HIDE_EDIT_CARD = 'HIDE_EDIT_CARD';
export const UPDATE_CARD = 'UPDATE_CARD';
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';
export const CLEAR_CUSTOMER = 'CLEAR_CUSTOMER';
//export const UPDATE_CARDS = 'UPDATE_CARDS';
export const CLEAR_CARD = 'CLEAR_CARD';
export const UPDATE_CUSTOMER_CARD = 'UPDATE_CUSTOMER_CARD';
export const ADD_CUSTOMER_CARD = 'ADD_CUSTOMER_CARD';

//export const CLEAR_CARDS = 'CLEAR_CARDS';
export const UPDATE_INVOICE = 'UPDATE_INVOICE';
export const UPDATE_INVOICES = 'UPDATE_INVOICES';
export const ADD_CHARGE = 'ADD_CHARGE';
export const UPDATE_CHARGE = 'UPDATE_CHARGE';
export const UPDATE_CHARGES = 'UPDATE_CHARGES';

//Tasks Constants
export const ADD_TASK = 'ADD_TASK';
export const TOGGLE_INITIALIZING_TASKS = 'TOGGLE_INITIALIZING_TASKS';
export const REMOVE_TASK = 'REMOVE_TASK';
export const UPDATE_TASK_PROGRESS = 'UPDATE_TASK_PROGRESS';
export const UPDATE_TASK_STATUS = 'UPDATE_TASK_STATUS';
export const BEGIN_FETCH_USERS_TASKS = 'BEGIN_FETCH_USERS_TASKS';
export const INIT_TASKS = 'INIT_TASKS';
export const INIT_TASKS_ASSIGNED_TO_ME = 'INIT_TASKS_ASSIGNED_TO_ME';
export const INIT_TASKS_ASSIGNED_BY_ME = 'INIT_TASKS_ASSIGNED_BY_ME';
export const TASK_UPDATE_SUCCESS = 'TASK_UPDATE_SUCCESS';
export const NEW_TASK_SUCCESS = 'NEW_TASK_SUCCESS';
export const NEW_TASK_FAILED = 'NEW_TASK_FAILED';
export const TASK_NEW_FAILED = 'TASK_NEW_FAILED';
export const DELETE_TASK = 'DELETE_TASK';
export const DELETE_TASK_SUCCESS = 'DELETE_TASK_SUCCESS';
export const DELETE_TASK_FAILED = 'DELETE_TASK_FAILED';
export const EDIT_TASK_SUCCESS = 'EDIT_TASK_SUCCESS';
export const ADD_NEW_TASK = 'ADD_NEW_TASK';
export const ADD_NEW_TASK_ASSIGNED_TO_ME = 'ADD_NEW_TASK_ASSIGNED_TO_ME';
export const ADD_NEW_TASK_ASSIGNED_BY_ME = 'ADD_NEW_TASK_ASSIGNED_BY_ME';
export const UPDATE_TASK = 'UPDATE_TASK';
export const TOGGLE_UPDATING_TASK = 'TOGGLE_UPDATING_TASK';
export const REQUEST_UPDATE_TASK = 'REQUEST_UPDATE_TASK';

//Live Weather Center
export const SUBMIT_MESSAGE = 'SUBMIT_MESSAGE';
export const DELETE_MESSAGE = 'DELETE_MESSAGE';
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';
export const SET_CHAT_STATUS = 'SET_CHAT_STATUS';
export const VIEW_CHAT = 'VIEW_CHAT';
export const VIEW_SETTINGS = 'VIEW_SETTINGS';
export const UPDATE_SCREEN_NAME = 'UPDATE_SCREEN_NAME';
export const UPDATE_AVATARS = 'UPDATE_AVATARS';
export const UPDATE_AVATAR = 'UPDATE_AVATAR';
export const UPDATE_LWC_FEED = 'UPDATE_LWC_FEED';

//Role Management
export const BEGIN_INIT_ROLES = 'BEGIN_INIT_ROLES';
export const FETCH_ROLES = 'FETCH_ROLES';
export const INITIALIZE_ROLES = 'INITIALIZE_ROLES';
export const INITIALIZE_ROLES_FAILED = 'INITIALIZE_ROLES_FAILED'
export const CHANGE_SELECTED_ROLE = 'CHANGE_SELECTED_ROLE';
export const SHOW_FEATURES = 'SHOW_FEATURES';
export const ADD_FEATURE_TO_STATE = 'ADD_FEATURE_TO_STATE';
export const REMOVE_FEATURE_FROM_STATE = 'REMOVE_FEATURE_FROM_STATE';
export const ADD_ROLE_TO_STATE = 'ADD_ROLE_TO_STATE';
export const DELETE_ROLE_FROM_STATE = 'DELETE_ROLE_FROM_STATE';
export const SET_ROLE_ERROR_MESSAGE = 'SET_ROLE_ERROR_MESSAGE';
export const SHOW_DELETE_ROLE_MODAL = 'SHOW_DELETE_ROLE_MODAL';
export const HIDE_DELETE_ROLE_MODAL = 'HIDE_DELETE_ROLE_MODAL';
export const ENABLE_FEATURE_SUCCESS = 'ENABLE_FEATURE_SUCCESS';
export const ENABLE_FEATURE_FAILED = 'ENABLE_FEATURE_FAILED';
export const DISABLE_FEATURE_SUCCESS = 'DISABLE_FEATURE_SUCCESS';
export const DISABLE_FEATURE_FAILED = 'DISABLE_FEATURE_FAILED';
export const BEGIN_ADD_ROLE = 'BEGIN_ADD_ROLE';
export const ADD_ROLE_SUCCESS = 'ADD_ROLE_SUCCESS';
export const ADD_ROLE_FAILED = 'ADD_ROLE_FAILED';
export const BEGIN_DELETE_ROLE = 'BEGIN_DELETE_ROLE';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_FAILED = 'DELETE_ROLE_FAILED';
export const ENABLE_FEATURE_FAILED_C = 'ENABLE_FEATURE_FAILED_C';
export const DISABLE_FEATURE_FAILED_C = 'DISABLE_FEATURE_FAILED_C';
export const HANDLE_CLICK_ROLE = 'HANDLE_CLICK_ROLE';
export const UPDATE_ROLE = 'UPDATE_ROLE';
export const EDIT_ROLE_SUCCESS = 'EDIT_ROLE_SUCCESS';
export const EDIT_ROLE_FAILED = 'EDIT_ROLE_FAILED';
export const EDIT_ROLE_FAILED_C = 'EDIT_ROLE_FAILED_C';

//Fields
export const FETCH_FIELDS = 'FETCH_FIELDS';
export const FETCH_FIELD = 'FETCH_FIELD';
export const CREATE_FIELD = 'CREATE_FIELD';
export const UPDATE_FIELD = 'UPDATE_FIELD';
export const DELETE_FIELD = 'DELETE_FIELD';
export const ADD_FIELD = 'ADD_FIELD';
export const ADD_FIELDS = 'ADD_FIELDS';
export const REMOVE_FIELD = 'REMOVE_FIELD';
export const CLEAR_FIELDS = 'CLEAR_FIELDS';

export const FETCH_FIELDS_SUCCESS = 'FETCH_FIELDS_SUCCESS';
export const FETCH_FIELD_SUCCESS = 'FETCH_FIELD_SUCCESS';
export const CREATE_FIELD_SUCCESS = 'CREATE_FIELD_SUCCESS';
export const UPDATE_FIELD_SUCCESS = 'UPDATE_FIELD_SUCCESS';
export const DELETE_FIELD_SUCCESS = 'DELETE_FIELD_SUCCESS';

export const FETCH_FIELDS_FAILED = 'FETCH_FIELDS_FAILED';
export const FETCH_FIELD_FAILED = 'FETCH_FIELD_FAILED';
export const CREATE_FIELD_FAILED = 'CREATE_FIELD_FAILED';
export const UPDATE_FIELD_FAILED = 'UPDATE_FIELD_FAILED';
export const DELETE_FIELD_FAILED = 'DELETE_FIELD_FAILED';

//Plans
export const TOGGLE_REQUESTING_CREATE_PLAN = 'TOGGLE_REQUESTING_CREATE_PLAN';
export const REQUEST_CREATE_PLAN = 'REQUEST_CREATE_PLAN';
export const CREATE_NEW_PLAN_SUCCESS = 'CREATE_NEW_PLAN_SUCCESS';
export const INIT_UPDATE_PLAN = 'INIT_UPDATE_PLAN';
export const TOGGLE_REQUESTING_UPDATE_PLAN = 'TOGGLE_REQUESTING_UPDATE_PLAN';
export const REQUEST_UPDATE_PLAN = 'REQUEST_UPDATE_PLAN';
export const UPDATE_PLAN_SUCCESS = 'UPDATE_PLAN_SUCCESS';
export const REQUEST_FETCH_PLANS = 'REQUEST_FETCH_PLANS';
export const FETCH_PLANS_SUCCESS = 'FETCH_PLANS_SUCCESS';
export const INIT_VIEW_PLAN_DETAILS = 'INIT_VIEW_PLAN_DETAILS';
export const TOGGLE_VIEWING_PLAN_DETAILS = 'TOGGLE_VIEWING_PLAN_DETAILS';
export const REQUEST_REMOVE_PLAN = 'REQUEST_REMOVE_PLAN';
export const TOGGLE_REMOVING_PLAN = 'TOGGLE_REMOVING_PLAN';
export const REMOVE_PLAN_SUCCESS = 'REMOVE_PLAN_SUCCESS';

//Jobs
export const FETCH_JOB = 'FETCH_JOB';
export const SET_CURRENT_JOB = 'SET_CURRENT_JOB';
export const SET_JOBS_SORT_COLUMN = 'SET_JOBS_SORT_COLUMN';
export const FETCH_JOBS = 'FETCH_JOBS';
export const FETCH_JOBS_SUCCESS = 'FETCH_JOBS_SUCCESS';
export const FETCH_JOBS_FAILED = 'FETCH_JOBS_FAILED';
export const FETCH_JOBS_FILTERS = 'FETCH_JOBS_FILTERS';
export const FETCH_JOBS_FILTERS_SUCCESS = 'FETCH_JOBS_FILTERS_SUCCESS';
export const FETCH_JOBS_FILTERS_FAILED = 'FETCH_JOBS_FILTERS_FAILED';
export const TOGGLE_JOBS_FILTER = 'TOGGLE_JOBS_FILTER';
export const UPDATE_JOB_KEYWORDS = 'UPDATE_JOB_KEYWORDS';
export const FETCH_NEXT_JOBS = 'FETCH_NEXT_JOBS';
export const FETCH_NEXT_JOBS_SUCCESS = 'FETCH_NEXT_JOBS_SUCCESS';
export const FETCH_NEXT_JOBS_FAILED = 'FETCH_NEXT_JOBS_FAILED';
export const SELECT_JOB = 'SELECT_JOB';
export const DESELECT_JOB = 'DESELECT_JOB';
export const PREVIEW_JOB = 'PREVIEW_JOB';
export const ADD_JOB = 'ADD_JOB';
export const START_CREATING_JOB = 'START_CREATING_JOB';
export const HIDE_CREATE_JOB = 'HIDE_CREATE_JOB';
export const REMOVE_JOB = 'REMOVE_JOB';
export const CREATE_JOB = 'CREATE_JOB';
export const CREATE_JOB_SUCCESS = 'CREATE_JOB_SUCCESS';
export const CREATE_JOB_FAILED = 'CREATE_JOB_FAILED';
export const DELETE_JOB = 'DELETE_JOB';
export const DELETE_JOB_SUCCESS = 'DELETE_JOB_SUCCESS';
export const DELETE_JOB_FAILED = 'DELETE_JOB_FAILED';
export const UPDATE_JOB = 'UPDATE_JOB';
export const UPDATE_JOB_SUCCESS = 'UPDATE_JOB_SUCCESS';
export const UPDATE_JOB_FAILED = 'UPDATE_JOB_FAILED';
export const TOGGLE_JOB_SELECT = 'TOGGLE_JOB_SELECT';
export const CLEAR_DOWNLOADED_JOBS = 'CLEAR_DOWNLOADED_JOBS';
export const SHOW_DELETE_JOB_CONFIRM = 'SHOW_DELETE_JOB_CONFIRM'

//ui
export const TOGGLE_INIT_FLAG = 'TOGGLE_INIT_FLAG';
export const TOGGLE_SHOW_SIDEBAR_CONTAINER = 'TOGGLE_SHOW_SIDEBAR_CONTAINER';
export const TOGGLE_SHOW_TASKS_SIDEBAR = 'TOGGLE_SHOW_TASKS_SIDEBAR';

/** Sales Site Manager **/

export const PAGE_CREATE = 'PAGE_CREATE';
export const PAGE_UPDATE = 'PAGE_UPDATE';
export const PAGE_DELETE = 'PAGE_DELETE';
export const PAGE_FETCH = 'PAGE_FETCH';
export const PAGE_CLEAR_STATE = 'PAGE_CLEAR_STATE';
export const PAGE_CREATE_SUCCESS = 'PAGE_CREATE_SUCCESS';
export const PAGE_UPDATE_SUCCESS = 'PAGE_UPDATE_SUCCESS';
export const PAGE_DELETE_SUCCESS = 'PAGE_DELETE_SUCCESS';
export const PAGE_FETCH_SUCCESS = 'PAGE_FETCH_SUCCESS';
export const PAGE_CREATE_FAILED = 'PAGE_CREATE_FAILED';
export const PAGE_UPDATE_FAILED = 'PAGE_UPDATE_FAILED';
export const PAGE_DELETE_FAILED = 'PAGE_DELETE_FAILED';
export const PAGE_FETCH_FAILED = 'PAGE_FETCH_FAILED';

export const PAGE_TEMPLATE_CREATE = 'PAGE_TEMPLATE_CREATE';
export const PAGE_TEMPLATE_UPDATE = 'PAGE_TEMPLATE_UPDATE';
export const PAGE_TEMPLATE_DELETE = 'PAGE_TEMPLATE_DELETE';
export const PAGE_TEMPLATE_FETCH = 'PAGE_TEMPLATE_FETCH';
export const PAGE_TEMPLATE_CLEAR_STATE = 'PAGE_TEMPLATE_CLEAR_STATE';

export const PAGE_TEMPLATE_CREATE_SUCCESS = 'PAGE_TEMPLATE_CREATE_SUCCESS';
export const PAGE_TEMPLATE_UPDATE_SUCCESS = 'PAGE_TEMPLATE_UPDATE_SUCCESS';
export const PAGE_TEMPLATE_DELETE_SUCCESS = 'PAGE_TEMPLATE_DELETE_SUCCESS';
export const PAGE_TEMPLATE_FETCH_SUCCESS = 'PAGE_TEMPLATE_FETCH_SUCCESS';
export const PAGE_TEMPLATE_CREATE_FAILED = 'PAGE_TEMPLATE_CREATE_FAILED';
export const PAGE_TEMPLATE_UPDATE_FAILED = 'PAGE_TEMPLATE_UPDATE_FAILED';
export const PAGE_TEMPLATE_DELETE_FAILED = 'PAGE_TEMPLATE_DELETE_FAILED';
export const PAGE_TEMPLATE_FETCH_FAILED = 'PAGE_TEMPLATE_FETCH_FAILED';

export const SECTION_CREATE = 'SECTION_CREATE';
export const SECTION_UPDATE = 'SECTION_UPDATE';
export const SECTION_DELETE = 'SECTION_DELETE';
export const SECTION_FETCH = 'SECTION_FETCH';
export const SECTION_CLEAR_STATE = 'SECTION_CLEAR_STATE';

export const SECTION_CREATE_SUCCESS = 'SECTION_CREATE_SUCCESS';
export const SECTION_UPDATE_SUCCESS = 'SECTION_UPDATE_SUCCESS';
export const SECTION_DELETE_SUCCESS = 'SECTION_DELETE_SUCCESS';
export const SECTION_FETCH_SUCCESS = 'SECTION_FETCH_SUCCESS';
export const SECTION_CREATE_FAILED = 'SECTION_CREATE_FAILED';
export const SECTION_UPDATE_FAILED = 'SECTION_UPDATE_FAILED';
export const SECTION_DELETE_FAILED = 'SECTION_DELETE_FAILED';
export const SECTION_FETCH_FAILED = 'SECTION_FETCH_FAILED';

export const SECTION_TEMPLATE_CREATE = 'SECTION_TEMPLATE_CREATE';
export const SECTION_TEMPLATE_UPDATE = 'SECTION_TEMPLATE_UPDATE';
export const SECTION_TEMPLATE_DELETE = 'SECTION_TEMPLATE_DELETE';
export const SECTION_TEMPLATE_FETCH = 'SECTION_TEMPLATE_FETCH';
export const SECTION_TEMPLATE_CLEAR_STATE = 'SECTION_TEMPLATE_CLEAR_STATE';

export const SECTION_TEMPLATE_CREATE_SUCCESS = 'SECTION_TEMPLATE_CREATE_SUCCESS';
export const SECTION_TEMPLATE_UPDATE_SUCCESS = 'SECTION_TEMPLATE_UPDATE_SUCCESS';
export const SECTION_TEMPLATE_DELETE_SUCCESS = 'SECTION_TEMPLATE_DELETE_SUCCESS';
export const SECTION_TEMPLATE_FETCH_SUCCESS = 'SECTION_TEMPLATE_FETCH_SUCCESS';
export const SECTION_TEMPLATE_CREATE_FAILED = 'SECTION_TEMPLATE_CREATE_FAILED';
export const SECTION_TEMPLATE_UPDATE_FAILED = 'SECTION_TEMPLATE_UPDATE_FAILED';
export const SECTION_TEMPLATE_DELETE_FAILED = 'SECTION_TEMPLATE_DELETE_FAILED';
export const SECTION_TEMPLATE_FETCH_FAILED = 'SECTION_TEMPLATE_FETCH_FAILED';

// Subsctiptions
export const SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS';
export const TOGGLE_FETCHING_SUBSCRIPTION = 'TOGGLE_FETCHING_SUBSCRIPTION';
export const TOGGLE_CREATING_SUBSCRIPTION = 'TOGGLE_CREATING_SUBSCRIPTION';
export const TOGGLE_CANCELING_SUBSCRIPTION = 'TOGGLE_CANCELING_SUBSCRIPTION';
export const TOGGLE_UPDATING_SUBSCRIPTION = 'TOGGLE_UPDATING_SUBSCRIPTION';
export const REQUEST_CREATE_SUBSCRIPTION = 'REQUEST_CREATE_SUBSCRIPTION';
export const REQUEST_FETCH_SUBSCRIPTION = 'REQUEST_FETCH_SUBSCRIPTION';
export const REQUEST_UPDATE_SUBSCRIPTION = 'REQUEST_UPDATE_SUBSCRIPTION';
export const REQUEST_CANCEL_SUBSCRIPTION = 'REQUEST_CANCEL_SUBSCRIPTION';
export const REQUEST_REACTIVATE_SUBSCRIPTION = 'REQUEST_REACTIVATE_SUBSCRIPTION';
export const CREATE_SUBSCRIPTION_SUCCESS = 'CREATE_SUBSCRIPTION_SUCCESS';
export const FETCH_SUBSCRIPTION_SUCCESS = 'FETCH_SUBSCRIPTION_SUCCESS';
export const UPDATE_SUBSCRIPTION_SUCCESS = 'UPDATE_SUBSCRIPTION_SUCCESS';
export const CANCEL_SUBSCRIPTION_SUCCESS = 'CANCEL_SUBSCRIPTION_SUCCESS';
export const REACTIVATE_SUBSCRIPTION_SUCCESS = 'REACTIVATE_SUBSCRIPTION_SUCCESS';
export const UPDATE_SUBSCRIPTION_WIZARD = 'UPDATE_SUBSCRIPTION_WIZARD';



// WEBPACK FOOTER //
// ./src/common/constants.js